import type { components } from "@/assets/api/openapi"
import { useAppApi } from "#imports"

export const useForeignTrainingData = () => {
  const appApi = useAppApi()
const { startLoading, stopLoading } = useLoading()  
  const referenceProfessionsStore = useReferenceProfessionsStore()

  const countries = ref<LocalizedCountry[]>()
  const educationSubjects = ref<components["schemas"]["EducationSubject"][]>([])
  const fetchSubjects = async () => {
    if (!referenceProfessionsStore.referenceProfession?.id) return

    startLoading()
    try {
      const { data, status } = await appApi.getSubjectByProfession(
        referenceProfessionsStore.referenceProfession.id
      )

      if (status === 200 && data) {
        educationSubjects.value = data
      } else {
        showToast("danger", {
          description: "Fächer konnten nicht geladen werden",
        })
      }
    } catch {
      showError({ statusCode: 500 })
    } finally {
      stopLoading()
    }
  }

  const fetchCountries = async () => {
    countries.value = await getCountryList({
      separatePassports: true,
      nonStateAreas: true,
      formerStates: false,
      noStateEntries: false,
    })
  }

  const loadForeignTraining = async (
    foreignTrainingId: number
  ): Promise<components["schemas"]["ForeignTraining"] | undefined> => {
    try {
      startLoading()
      const { data, status } =
        await appApi.getForeignTraining(foreignTrainingId)

      if (status === 200 && data) {
        return data
      } else {
        showToast("danger", {
          description: "Ausländische Ausbildung konnten nicht geladen werden",
        })
      }
    } catch (error) {
      showError({
        statusCode: 500,
      })
    } finally {
      stopLoading()
    }
  }

  const saveForeignTraining = async (
    payload: components["schemas"]["ForeignTraining"]
  ) => {
    return await appApi.createOrUpdateForeignTraining(payload)
  }

  const deleteForeignTraining = async (foreignTrainingId: number) => {
    const { status } = await appApi.deleteForeignTraining(foreignTrainingId)
    return status
  }

  return {
    countries,
    educationSubjects,
    fetchCountries,
    fetchSubjects,
    loadForeignTraining,
    saveForeignTraining,
    deleteForeignTraining,
  }
}
